import { render, staticRenderFns } from "./ContactPersonPhoto.vue?vue&type=template&id=5ba03ad0&"
import script from "./ContactPersonPhoto.vue?vue&type=script&lang=ts&"
export * from "./ContactPersonPhoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports